import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, IonicApp, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DbservicesProvider,ChatService } from '../providers/dbservices/dbservices';
import { HomePage } from '../pages/home/home';
import { ReservationPage } from '../pages/reservation/reservation';
import { LoginPage } from '../pages/login/login';
import { OneSignal } from '@ionic-native/onesignal';
import { NativeAudio } from '@ionic-native/native-audio';
import { AddPrinterPage } from '../pages/add-printer/add-printer'
import { DashboardPage } from '../pages/dashboard/dashboard'
import {DeliveryTimePage} from '../pages/delivery-time/delivery-time';
import { OrderdetailsPage } from '../pages/orderdetails/orderdetails';

import { BackgroundMode } from '@ionic-native/background-mode';
import {ReportlistPage} from '../pages/reportlist/reportlist';
import {SalesReportPage} from '../pages/sales-report/sales-report';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  adminname;
  adminemail;
  rootPage: any;
  back_clicked = 0;
  pages: Array<{ title: string, icon: string, iconname: any, component: any, color: any }>;
  constructor(private app: App, private ionicApp: IonicApp, private chatService: ChatService,private backgroundMode: BackgroundMode, public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public DBservice: DbservicesProvider, public alertCtrl: AlertController, private nativeAudio: NativeAudio, public oneSignal: OneSignal) {
    this.initializeApp();
    this.get_Url()
    this.backgroundMode.enable();
            this.backgroundMode.setDefaults({
    title: 'Badaling',
    text: 'Restaurant admin order notification app',
    icon: 'icon', // this will look for icon.png in platforms/android/res/drawable|mipmap
    color: '#F14F4D', // hex format like 'F14F4D'
    resume: true,
    bigText: true
})

          this.backgroundMode.overrideBackButton();
            
    this.backgroundMode.setDefaults({ silent: false });

    // this.backgroundMode.enable();
    this.adminname = this.DBservice.adminname
    this.adminemail = this.DBservice.adminemail
    if (localStorage.AdminId == undefined) {
      this.rootPage = LoginPage;
    }
    else {
      this.rootPage = DashboardPage;
    }

    if(localStorage.check_default == undefined)
      localStorage.check_default = true;

    this.triggerNotification()

    this.pages = [
      { title: 'Dashboard', component: DashboardPage, iconname: 'custom-home', icon: 'assets/imgs/home-r.svg', color: 'fagrey' },
      { title: 'Orders', component: HomePage, iconname: 'custom-order', icon: 'assets/imgs/home-r.svg', color: 'fagrey' },
      { title: 'Menu Availability', component: ReservationPage, iconname: 'custom-menu', icon: 'assets/imgs/order-r.svg', color: 'fagrey' },
      { title: 'Report', component: ReportlistPage, iconname: 'custom-report', icon: 'assets/imgs/order-r.svg', color: 'fagrey' },
      { title: 'Sales Report', component: SalesReportPage, iconname: 'custom-report', icon: 'assets/imgs/order-r.svg', color: 'fagrey' },
      { title: 'Settings', component:AddPrinterPage , iconname: 'custom-setting', icon: 'assets/imgs/menu/my-account.svg', color: 'fagrey' },
      { title: 'Preparation time', component:DeliveryTimePage , iconname: 'custom-preparationtime', icon: 'assets/imgs/menu/my-account.svg', color: 'fagrey' }
    ];
    // if (this.platform.is('android'))
    //   this.getversion();
  }

   get_Url() {
    this.DBservice.get_url()
      .subscribe(res => {
        // this.DBservice.domain = res.domain;
        // this.DBservice.restaurant = res.businessId;
        this.DBservice.baseUrl = res;
        this.chatService.socketurl = res;
        this.DBservice.baseResource = res + '/api/resource/'
        this.DBservice.baseMethod = res + '/api/method/'
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  getversion() {
    var appVersion = "0.0.7"
    var starCount;
    this.DBservice.get_version()
      .subscribe(res => {
        starCount = res;
        if (starCount != appVersion) {
          this.versionerr(appVersion, starCount);
          this.platform.ready().then(() => {
            this.platform.registerBackButtonAction((e) => {
              e.preventDefault();
            })
          })
        }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  initializeApp() {
    this.platform.ready().then(() => {

      this.statusBar.backgroundColorByHexString('#bf002c');
      this.splashScreen.hide();
    });
    this.platform.registerBackButtonAction(() => {
      let nav = this.app.getActiveNavs()[0];
      let activeView = nav.getActive();
      console.log(activeView);
      this.back_clicked = this.back_clicked + 1;
      let activePortal = this.ionicApp._loadingPortal.getActive() || // Close If Any Loader Active
        this.ionicApp._modalPortal.getActive() ||  // Close If Any Modal Active
        this.ionicApp._overlayPortal.getActive();
      if(activePortal){
        activePortal.dismiss();
      } else if(nav.canGoBack()){
          this.back_clicked = 0;
          nav.pop();
      } else {
          if(activeView.id == 'DashboardPage' && this.back_clicked == 2){
              let alt = this.alertCtrl.create({
                  // title: ''
                  subTitle: 'Do you really want to quit this app?',
                  buttons: [{
                      text: 'No',
                      role: 'cancel',
                      handler: () => {
                          this.back_clicked = 0;
                      }
                  }, {
                      text: 'Yes',
                      handler: () =>{
                          this.back_clicked = 0;
                          this.platform.exitApp();
                      }
                  }]
              });
              alt.present();
          } else if(activeView.id != 'DashboardPage'){
              this.back_clicked = 0;
              // location.href = '#/dashboard';
              this.nav.setRoot(DashboardPage);
              // this.nav.push('HomePage');
              // try{
              //   activeView.instance.navCtrl.pop();
              // } catch(e){
              //   console.log(e)
              //   this.nav.push('HomePage');
              // }
              // if(activeView.instance.navCtrl && activeView.instance.navCtrl.canGoBack()){
              //   activeView.instance.navCtrl.pop();
              // } else{
              //   this.nav.push('HomePage');
              // }
          }                
        }
        setTimeout(() => {
            this.back_clicked = 0;
        }, 5000);
    });
  }

  openPage(page, index) {
    // console.log(page.component)
    // if(page.title == 'Report'){
    //   this.nav.push(page.component);
    // }
    // else 
      this.nav.setRoot(page.component);
  }

  goto_site() {
    window.open('https://www.tridotstech.com/', '_system')
  }

  versionerr(newv, oldv) {
    let alert = this.alertCtrl.create({
      title: 'Update Available',
      message: 'A new version(' + newv + ') of this app is available for download. Must update it from PlayStore !',
      subTitle: 'current version : ' + oldv,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
            this.platform.exitApp();
          }
        },
        {
          text: 'Update',
          handler: () => {
            console.log('Buy clicked');
            window.open("https://play.google.com/store/apps/details?id=com.admingodabao", '_system');
            this.platform.exitApp();
          }
        }
      ]
    });
    alert.present();
  }


  logout() {
    let alert = this.alertCtrl.create({
      subTitle: 'Are sure to logout of this app?',
      buttons: [{
        'text': 'Cancel',
        'role': 'cancel',
        handler: () => {

        }
      }, {
        'text': 'Ok',
        handler: () => {
          var datas = {
            document:'Shop User',
            user:localStorage.adminRefId,
            device_id:localStorage.deviceid,
            enabled:0
          }
          this.DBservice.update_playerid(datas)
            .then(data => {
              console.log(data)
            }, error => {
              console.log(JSON.stringify(error.json()));

            });
          var deviceid = localStorage.deviceid;
          localStorage.clear();
          localStorage.deviceid = deviceid;
          this.DBservice.adminname = ''
          this.DBservice.adminemail = ''
          this.nav.setRoot(LoginPage)
        }
      }]
    })
    alert.present();
  }

  login() {
    location.href = "#/login"
  }

  triggerNotification() {
    if (this.platform.is('cordova')) {
      this.platform.ready().then(() => {
        this.nativeAudio.preloadSimple('sound', 'assets/sound.mp3').then(() => {
        }).catch((err) => {
          console.log(err);
        });

        this.oneSignal.startInit('9dd335f1-0098-4a45-9fc8-16e98cb67593', '1082048324731');

        this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);

        this.oneSignal.handleNotificationReceived().subscribe((data) => {
          console.log(data)
          this.backgroundMode.enable();
          // this.backgroundMode.unlock();
          this.backgroundMode.isScreenOff().then((data)=>{
              // Turn screen on
              this.backgroundMode.wakeUp();
// Turn screen on and show app even locked
              this.backgroundMode.unlock();
          })


          this.backgroundMode.setDefaults({
    title: 'Badaling',
    text: 'Restaurant admin order notification app',
    icon: 'icon', // this will look for icon.png in platforms/android/res/drawable|mipmap
    color: '#F14F4D', // hex format like 'F14F4D'
    resume: true,
    bigText: true
})
//           this.backgroundMode.isScreenOff((bool) {

//           this.backgroundMode.unlock();
// });
          this.backgroundMode.moveToForeground();

          this.backgroundMode.overrideBackButton();
          
          // this.backgroundMode.enable();
          this.nativeAudio.play('sound').then(() => {
          }).catch((err) => {
            console.log(err);
          });
          let alert = this.alertCtrl.create({
            // title: data.payload.body,
            title: 'New Order #' + data.payload.body,
            message: '<img src="assets/imgs/new-order-notification.png" style="width: 100%;">',
            cssClass:'notificationcss',   
            buttons: [
            {
                text: 'View Order',
                handler: () => {
                  let alertTransition = alert.dismiss();
                  alertTransition.then(() => {
                    this.nativeAudio.stop('sound')
                     // this.nav.setRoot(HomePage)
                     var orderdata = {
                      restaurantId:localStorage.restaurant,
                      limit_start: 0,
                      limit_page_length: 5,
                      status: 'Placed'
                    }
                    this.DBservice.order_list(orderdata)
                      .then(res => {
                        console.log(res);
                        if (res.message != undefined) {
                          for (var i = 0; i < res.message.length; i++) {
                            var k = i;
                            if(res.message[k].name == data.payload.body)
                            // {
                              this.nav.push(OrderdetailsPage,{ item: res.message[k]})
                              // break;
                            // }
                            // console.log(this.order_list)
                          }
                        }
                         }, error => {
                      console.log(JSON.stringify(error.json()));
                      });
                    
                  });
                  return false;
                }
              
              }]
            // buttons: [
            //   {
            //     text: 'Decline',
            //     handler: () => {
            //       let alertTransition = alert.dismiss();
            //       alertTransition.then(() => {
            //         this.nativeAudio.stop('sound')

            //         var datas = {
            //           status: 'Restaurant Declined',
            //           name:data.payload.body
            //         }
            //         this.DBservice.update_order(datas)
            //           .then(data => {
            //             console.log(data);
            //           }, error => {
            //             console.log(JSON.stringify(error.json()));
            //           });

            //       });
            //       return false;
            //     }
            //   },
            //   {
            //     text: 'Accept',
            //     handler: () => {
            //       let alertTransition = alert.dismiss();
            //       alertTransition.then(() => {
            //         this.nativeAudio.stop('sound')
            //         var datas = {
            //           status: 'Restaurant Accepted',
            //           name:data.payload.body
            //         }
            //         this.DBservice.update_order(datas)
            //           .then(data => {
            //             console.log(data);
            //           }, error => {
            //             console.log(JSON.stringify(error.json()));
            //           });
            //       });
            //       return false;
            //     }
            //   }]
          });
          alert.present();
        });

        this.oneSignal.handleNotificationOpened().subscribe((data) => {
          console.log('didOpenRemoteNotificationCallBack: ' + JSON.stringify(data));
        })

        this.oneSignal.endInit();

        this.oneSignal.getIds().then((data) => {
          localStorage.deviceid = data.userId;
        })
      });

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts